<script>
import TextareaField from "@/components/input/TextareaField.vue";
import {api} from "@/modules/api";
import {toast} from "vue3-toastify";

export default {
  name: 'FormReviewUpdate',
  components: {TextareaField},
  props: {
    review: Object
  },
  data () {
    return {
      formData: {
        note: 0
      }
    }
  },
  mounted () {
    this.formData.note = this.review.note
    this.formData.text = this.review.Text
  },
  methods: {
    addNote (index, star) {
      if (star === 'plein') {
        this.formData.note = index
      } else {
        this.formData.note += index
      }
    },
    submit () {
      api.reviews.update(this.review.id, this.formData).then(() => {
        this.$emit('closeModal')
        this.emitter.emit('load-data', true)
        toast('Votre avis a été modifié !')
      })
    }
  }
}
</script>

<template>
  <div class="p-4 md:p-5">
    <div class="mb-4 grid grid-cols-2 gap-4">
      <div class="col-span-2">
        <div class="flex items-center">
          <div class="flex items-center gap-1">
            <i v-for="index in formData.note" :key="'full-' + index" @click="addNote(index, 'plein')" class="fa-solid fa-star text-yellow-300"></i>
            <i v-for="index in (5 - formData.note)" :key="'empty-' + index" @click="addNote(index, 'vide')" class="fa-regular fa-star text-yellow-300"></i>
          </div>
          <span class="ms-2 text-lg font-bold text-gray-900 dark:text-white">
            {{ formData.note }}/5
          </span>
        </div>
      </div>
      <div class="col-span-2">
        <textarea-field
            v-model="formData.text"
            label="Votre avis"
        />
      </div>
    </div>
    <div class="border-t border-gray-200 pt-4 dark:border-gray-700 md:pt-5">
      <button @click="submit" class="me-2 inline-flex items-center rounded-lg bg-primary-700 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-primary-800">
        Ajouter avis
      </button>
      <button @click="$emit('closeModal')" class="me-2 rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-medium text-gray-900 hover:bg-gray-100 hover:text-primary-700">
        Annuler
      </button>
    </div>
  </div>
</template>

<style scoped>

</style>